import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getProductPurchaseInput,
  getProductsPurchaseInput,
  ProductPurchaseLiteModel,
  ProductPurchaseModel,
} from './model';

export function useGetProductsPurchase(
  input?: getProductsPurchaseInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ProductPurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ProductPurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['product-purchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'product-purchases',
          params: input?.params,
        }),
      options,
    ),
    ProductPurchaseLiteModel,
  );
}

export function useGetProductPurchase(
  input?: getProductPurchaseInput,
  options?: UseQueryOptions<ApiResult<ProductPurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<ProductPurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['product-purchases', input?.id],
      () =>
        QueryFetchFunction({
          url: `product-purchases/${input?.id}`,
        }),
      options,
    ),
    ProductPurchaseModel,
  );
}

export function getProductsPurchaseKey(input?: getProductsPurchaseInput) {
  return ['product-purchases', input?.params];
}

export function getProductPurchaseKey(input?: getProductPurchaseInput) {
  return ['product-purchases', input?.id];
}
